import datos from "src/services/datos";

const contenidos = new datos("contenidos");
export const updateSp = async (data) => {
  contenidos.addCondition("contenidos", "id", 0, ">");
  const response = await contenidos.spUpdate(data);
  return response;
};
